export default __webpack_public_path__ + "static/media/Grips of the Inconceivable.e7096099.jpg";